import { useMemo } from "react";

import { useGetSignals } from "@/queries/signals";

export const useWorkspaceSignalNames = (
  userToken: string | null | undefined,
  workspaceId: number | null | undefined,
): Map<number, string> => {
  const { data } = useGetSignals({
    userToken: userToken ?? "",
    workspaceId: workspaceId ?? 0,
    perPage: 100,
    enabled: Boolean(userToken && workspaceId),
  });

  return useMemo(() => {
    const namesById = new Map<number, string>();
    for (const signal of data?.signals ?? []) {
      namesById.set(signal.id, signal.name);
    }
    return namesById;
  }, [data?.signals]);
};
